<template>
    <div class="pop__side_library">
        <div class="pop__side_box_main_inner pop__side_library_box_main_inner">
            <div class="pop__side_library_box_main_inner_email">
                <component-library
                    :allow-multiple="allowMultiple"
                    :only-select="true"
                    :filter-actions-active="false"
                    :customer-id="customerId"
                    :formats="formats"
                    ref="componentlibrary"
                />
            </div>
        </div>
    </div>
</template>

<script>
import ComponentLibrary from '@/components/default/shared/ComponentLibrary'

export default {
  components: {
    ComponentLibrary
  },
  name: 'pop-side-library',
  props: {
    allowMultiple: {
      type: Boolean
    },
    customerId: {
      type: String
    },
    formats: {
      type: String
    }
  },
  methods: {
    openFileUploader () {
      this.$refs.componentlibrary.openFileUploader()
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/popsidelibrary";
</style>
